import { FEATURE_KEYS } from "../../access-control/models/role-feature.models";
import { ADMIN_FLOW_VIEWS } from "../../admin-agent/utils/admin-flows.constants";
import { ADMIN_PATHS, AdminSidebarDrawerSection, AdminSidebarFeatureSection } from "../models/admin.models";
import { ADMIN_AI_SCAN_TYPES } from "./admin-ai-scans.constants";

export const ADMIN_SIDEBAR_POPOVER_VIEWPORT_PADDING = 16;

export const ADMIN_AI_SCAN_SECTIONS: AdminSidebarDrawerSection[] = ADMIN_AI_SCAN_TYPES.map((scan) => ({
  id: scan.id,
  label: scan.label,
  path: `${ADMIN_PATHS.aiScans}/${scan.id}`,
  dataTest: `admin-sidebar-ai-scans-${scan.id}-link`,
}));

export const ADMIN_AI_LAB_SECTIONS: AdminSidebarDrawerSection[] = ADMIN_FLOW_VIEWS.map((view) => ({
  id: view.id,
  label: view.label,
  path: `${ADMIN_PATHS.aiFlows}/${view.id}`,
  dataTest: `admin-sidebar-ai-lab-${view.id}-link`,
}));

export const ADMIN_CERTIFICATES_SECTIONS: AdminSidebarFeatureSection[] = [
  {
    id: "certificatesSettings",
    label: "Settings",
    path: ADMIN_PATHS.certificatesSettings,
    dataTest: "admin-sidebar-certificates-settings-link",
    requiredFeatureKeys: [FEATURE_KEYS.ADMIN_REF_PARAMETERS_CERTS],
  },
  {
    id: "kpis",
    label: "KPIs",
    path: ADMIN_PATHS.kpis,
    dataTest: "admin-sidebar-kpis-link",
    requiredFeatureKeys: [FEATURE_KEYS.ADMIN_ANALYTICS_CERTS],
  },
];
